<template>
  <section class="clientcreate">
    <header class="header">
    </header>

    <form @submit.prevent="handleCreateClient">
      <f-card>
        <template slot="header"></template>

        <template>
          <div class="row">
            <span class="label">Informations Principales</span>
            <div class="inputs">
              <ab-input id="label" type="text" class="mandatory" v-model="label" name="label" label="Nom de l'établissement"></ab-input>
              <div class="wrap">
                <ab-input id="email" type="email" class="mandatory input-group" v-model="email" name="email" label="Email client"></ab-input>
                <ab-input id="email-notif" type="email" class="mandatory input-group" v-model="emailNotif" name="email-notif" label="Email client Facilitéo"></ab-input>
                <ab-input id="phone" type="text" class="mandatory input-group" v-model="phone" name="phone" label="Téléphone"></ab-input>
                <ab-input id="address" type="text" class="mandatory input-group" v-model="address" name="address" label="Siège social"></ab-input>
                <ab-input id="siren" type="text" class="mandatory input-group" v-model="siren" name="siren" label="siren"></ab-input>
                <div class="symbol input-group flex flex-space">
                  <ab-input id="initialstock" type="number" v-model="initialStock" name="initialStock" label="Stock initial"></ab-input><span>€</span>
                </div>
                <div class="symbol input-group flex flex-space">
                  <ab-input id="initialsales" type="number" v-model="initialSales" name="initialSales" label="CA initial"></ab-input><span>€</span>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <span class="label">Objectif ratio Achat / Chiffre d'affaires</span>
            <div class="inputs wrap">
              <!-- <div class="symbol input-group flex flex-space">
                <ab-input id="salefigure" type="number" v-model="salefigure" name="salefigure" label="Chiffre d'affaires initial"></ab-input><span>€</span>
              </div>
              <ab-input id="guests" type="number" class="input-group" v-model="guests" name="guests" label="Nombre de couverts initial"></ab-input> -->
              <div class="symbol input-group flex flex-space">
                <ab-input id="alimentary" type="number" v-model="alimentary" name="alimentary" label="Alimentaire"></ab-input><span>%</span>
              </div>
              <div class="symbol input-group flex flex-space">
                <ab-input id="drink" type="number" v-model="drink" name="drink" label="Boisson"></ab-input><span>%</span>
              </div>
              <div class="symbol input-group flex flex-space">
                <ab-input id="nonalimentary" type="number" v-model="nonAlimentary" name="nonAlimentary" label="Non alimentaire"></ab-input><span>%</span>
              </div>
              <div class="symbol input-group flex flex-space">
                <ab-input id="averageticket" type="number" v-model="averageTicket" name="averageTicket" label="Ticket moyen"></ab-input><span>€</span>
              </div>
              <div class="symbol input-group flex flex-space">
                <ab-input id="ebit" type="number" v-model="ebit" name="ebit" label="Marge brute sur consommation cible"></ab-input><span>%</span>
              </div>
              <div class="input-group">
                <f-checkbox v-model="enableAverageTiket" id="enable_average_tiket" name="enable_average_tiket">Gestion ticket moyen</f-checkbox>
              </div>
            </div>
          </div>
          <div class="row">
            <span class="label">Jours de fermeture</span>
            <div class="inputs">
              <div class="wrap">
                <f-checkbox v-model="monday" id="monday" name="monday">Lundi</f-checkbox>
                <f-checkbox v-model="tuesday" id="tuesday" name="tuesday">Mardi</f-checkbox>
                <f-checkbox v-model="wednesday" id="wednesday" name="wednesday">Mercredi</f-checkbox>
                <f-checkbox v-model="thursday" id="thursday" name="thursday">Jeudi</f-checkbox>
                <f-checkbox v-model="friday" id="friday" name="friday">Vendredi</f-checkbox>
                <f-checkbox v-model="saturday" id="saturday" name="saturday">Samedi</f-checkbox>
                <f-checkbox v-model="sunday" id="sunday" name="sunday">Dimanche</f-checkbox>
              </div>
              <div class="row close-date">
                <f-checkbox v-model="exceptional" id="exceptional" name="exceptional" @input="handleCalendarValues">Fermeture exceptionnelle</f-checkbox>
                <datepicker
                  id="start"
                  ref="start"
                  v-model="start"
                  :monday-first="true"
                  format="dd/MM/yyyy"
                  placeholder="JJ/MM/AAAA"
                  :language="fr"
                  :disabled-dates="computedDisabledDateFrom"
                  :disabled="isDisabled"
                  class="f-datepicker">
                  <span slot="afterDateInput" class="bar"></span>
                </datepicker>
                au
                <datepicker
                  id="end"
                  ref="end"
                  v-model="end"
                  :monday-first="true"
                  format="dd/MM/yyyy"
                  placeholder="JJ/MM/AAAA"
                  :language="fr"
                  :disabled-dates="computedDisabledDateTo"
                  :disabled="isDisabled"
                  class="f-datepicker">
                  <span slot="afterDateInput" class="bar"></span>
                </datepicker>
              </div>
            </div>
          </div>
        </template>

        <template slot="footer">
          <div class="row flex-container">
            <a @click="$router.go(-1)" class="btn-action">Annuler</a>
            <ab-button class="primary">Sauvegarder</ab-button>
          </div>
        </template>
      </f-card>
    </form>

  </section>
</template>

<script>
  import AbInput from '@/components/form/input/ab-input.vue';
  import AbButton from '@/components/form/button/ab-button.vue';
  import FCard from '@/components/layout/card/f-card.vue';
  import FCheckbox from '@/components/form/input/f-checkbox.vue';
  import Datepicker from 'vuejs-datepicker';
  import {fr} from 'vuejs-datepicker/dist/locale';
  import { mapState } from 'vuex';
  // Import error message files
  import messages from '../../../messages/messages.js';
  import clientEdit from '@/components/mixins/clientCalendar.js';

  export default {
    name: 'ClientCreate',
    mixins: [ clientEdit ],
    components: {
      AbInput,
      AbButton,
      FCard,
      FCheckbox,
      Datepicker
    },
    data() {
      return {
        label: '',
        email: '',
        emailNotif: '',
        phone: '',
        address: '',
        siren: '',
        initialStock: '',
        initialSales: '',
        salefigure: '',
        guests: '',
        alimentary: '',
        drink: '',
        nonAlimentary: '',
        averageTicket: '',
        enableAverageTiket: false,
        ebit: '',
        monday: false,
        tuesday: false,
        wednesday: false,
        thursday: false,
        friday: false,
        saturday: false,
        sunday: false,
        exceptional: false,
        start: '',
        end: '',
        fr: fr,
      }
    },
    computed: {
      isDisabled() { return !this.exceptional },
    },
    methods: {
      async handleCreateClient() {
        const label = this.$el.querySelector('#label input');
        const siren = this.$el.querySelector('#siren input');
        const email = this.$el.querySelector('#email input');
        const emailNotif = this.$el.querySelector('#email-notif input');
        const phone = this.$el.querySelector('#phone input');
        const address = this.$el.querySelector('#address input');
        const initialStock = this.$el.querySelector('#initialstock input');
        const initialSales = this.$el.querySelector('#initialsales input');
        const guests = this.$el.querySelector('#guests input');
        const alimentary = this.$el.querySelector('#alimentary input');
        const drink = this.$el.querySelector('#drink input');
        const nonAlimentary = this.$el.querySelector('#nonalimentary input');
        const averageTicket = this.$el.querySelector('#averageticket input');
        const ebit = this.$el.querySelector('#ebit input');
        const startEl = this.$el.querySelector('#start');
        const endEl = this.$el.querySelector('#end');

        label.classList.remove('error');
        siren.classList.remove('error');
        email.classList.remove('error');
        emailNotif.classList.remove('error');
        phone.classList.remove('error');
        address.classList.remove('error');
        initialStock.classList.remove('error');
        initialSales.classList.remove('error');
        alimentary.classList.remove('error');
        drink.classList.remove('error');
        nonAlimentary.classList.remove('error');
        averageTicket.classList.remove('error');
        ebit.classList.remove('error');
        startEl.classList.remove('error');
        endEl.classList.remove('error');

        if (this.label != "" && this.siren != "" && this.email != "" && this.emailNotif != '' && this.phone != ""  && this.address != "") {
          // Check number inputs
          if (this.initialStock < 0 || this.initialSales < 0 || this.guests < 0 || this.alimentary < 0 || this.drink < 0 || this.nonAlimentary < 0 || this.averageTicket < 0 || this.ebit < 0) {
            if (this.initialStock < 0) { initialStock.classList.add('error'); }
            if (this.initialSales < 0) { initialSales.classList.add('error'); }
            if (this.guests < 0) { guests.classList.add('error'); }
            if (this.alimentary < 0) { alimentary.classList.add('error'); }
            if (this.drink < 0) { drink.classList.add('error'); }
            if (this.nonAlimentary < 0) { nonAlimentary.classList.add('error'); }
            if (this.averageTicket < 0) { averageTicket.classList.add('error'); }
            if (this.ebit < 0) { ebit.classList.add('error'); }
            this.displayToast({ message: messages.clients.global.custom.number, mode: 'error' });
            return;
          }

          // Check sum of purcentages
          if (Number(this.alimentary) + Number(this.drink) + Number(this.nonAlimentary) + Number(this.ebit) > 100) {
            alimentary.classList.add('error');
            drink.classList.add('error');
            nonAlimentary.classList.add('error');
            ebit.classList.add('error');
            this.displayToast({ message: messages.clients.global.custom.purcentage, mode: 'error' });
            return;
          }

          // Check if start date is after end date
          let start = (this.start) ? this.start.getTime() : '';
          let end = (this.end) ? this.end.getTime() : '';
          if (start > end) {
            startEl.classList.add('error');
            endEl.classList.add('error');
            this.displayToast({ message: messages.clients.global.custom.dates, mode: 'error' });
            return;
          }

          const data = await this.$store.dispatch('createClient', {
            label: this.label,
            email: this.email,
            notification_email: this.emailNotif,
            phone: this.phone,
            address_1: this.address,
            siren: this.siren,
            stock: this.initialStock,
            sales: this.initialSales,
            alimentary: this.alimentary,
            non_alimentary: this.nonAlimentary,
            drink: this.drink,
            average_ticket: this.averageTicket,
            enable_average_tiket: this.enableAverageTiket,
            ebit: this.ebit,
            monday: this.monday,
            tuesday: this.tuesday,
            wednesday: this.wednesday,
            thursday: this.thursday,
            friday: this.friday,
            saturday: this.saturday,
            sunday: this.sunday,
            start: start,
            end: end,
          });
          // TODO : changer quand Nico aura changé sa réponse
          if (data.client && data.client.id) {
            this.displayToast({ message: messages.clients.ClientCreate.custom.success });
            this.$router.push({ name: 'ClientList' });
          }
          else {
            this.displayToast({ message: messages.clients.global.custom.error, mode: 'error' });
          }
        }
        else {
          this.displayToast({ message: messages.clients.global.custom.mandatory, mode: 'error' });
          if (!this.label) { label.classList.add('error'); }
          if (!this.siren) { siren.classList.add('error'); }
          if (!this.email) { email.classList.add('error'); }
          if (!this.emailNotif) { emailNotif.classList.add('error'); }
          if (!this.phone) { phone.classList.add('error'); }
          if (!this.address) { address.classList.add('error'); }
        }
      },
    },
  }
</script>

<style scoped>
  /* FCard display */
  .row {
    margin-bottom: 1.5rem;
  }
  .row .label {
    color: var(--app-dark-grey);
    font-weight: 600;
    font-size: 15px;
    line-height: 27px;
    vertical-align: top;
    padding-right: 1.5rem;
  }
  .inputs {
    margin-top: 16px;
  }
  .wrap {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
  }
  .input-group {
    width: 45%;
  }
  /* Inputs with symbol */
  .symbol {
    align-items: baseline;
  }
  .symbol .ab-input {
    width: 100%;
  }
  .symbol .ab-input input {
    text-align: right;
  }
  /* Spacing for each section */
  section {
    margin-bottom: 2.5rem;
  }
  /* Footer */
  .flex-container {
    display: flex;
    justify-content: flex-end;
  }
  footer .btn-action {
    margin-right: 1rem;
    cursor: pointer;
  }
  /* Datepickers */
  .f-datepicker {
    margin: -0.15rem 1rem;
  }
</style>
<style>
  /* Place calendar */
  .clientcreate .vdp-datepicker__calendar {
    right: 0;
    bottom: 5rem;
  }
</style>
<style src="@/assets/styles/datepickers.css"></style>